const getNodeKey  = ({ node }) => node.id

export default { getNodeKey }
